import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SlideInfo from './slide_info';
import NextSlideButton from './buttons/next_slide';
import PreviousSlideButton from './buttons/previous_slide';
import SeeAllSlidesButton from './buttons/see_all_slides';
import {
  getPreviousSlideLocation,
  getNextSlideLocation,
  refreshAds
} from '../../../../utils/slideshow';
import {get, some} from 'lodash';

export default class NavBar extends Component {
  shouldComponentUpdate = (nextProps) => some([
    'slideIndex',
    'upNextUrl',
    'location.pathname'
  ], prop => get(nextProps, prop) !== get(this.props, prop));

  
  
  render() {
    const { handleChangeSlide, handleSeeAllSlidesClick,
      location, slideIndex, slideCount, upNextUrl } = this.props;

    const changeSlide = () => {
      refreshAds();
      handleChangeSlide();
    }

    const previousSlideLocation =
      getPreviousSlideLocation(slideIndex, location);
    const nextSlideLocation =
      getNextSlideLocation(slideIndex, location, slideCount);

    return (
      <div className="slideshow-nav">
        <PreviousSlideButton slideIndex={slideIndex}
          handleClick={changeSlide}
          slideLocation={previousSlideLocation}
        />
        <SeeAllSlidesButton handleClick={handleSeeAllSlidesClick} />
        <NextSlideButton slideIndex={slideIndex}
          handleClick={changeSlide}
          slideLocation={nextSlideLocation}
          upNextUrl={upNextUrl}
        />
        <SlideInfo {...this.props}
          slideIndex={slideIndex}
          nextSlideLocation={nextSlideLocation}
        />
      </div>
    );
  }
}

NavBar.propTypes = {
  handleChangeSlide: PropTypes.func.isRequired,
  handleSeeAllSlidesClick: PropTypes.func.isRequired,
  location: PropTypes.object,
  slideCount: PropTypes.number.isRequired,
  slideIndex: PropTypes.number.isRequired,
  upNextUrl: PropTypes.string
};
